import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import {
  useFestivalWatchlistAddMutation,
  useFestivalWatchlistRemoveMutation,
} from '@mwxltd/flix-api-client'
import commonFestivalMsgs from '@flix/common/domain/festival/messages'
import { OverrideButtonHandlers } from '@flix/common/elements/controls/ButtonHandlerContext/ButtonHandlerContext'
import { useSnackbar } from '../../../containers/app/Snackbar/SnackbarContext'

export const FestivalButtonHandlersProvider = ({ children }) => {
  const history = useHistory()
  const { snackbarMsg, snackbarError } = useSnackbar()

  const [addToWatchList] = useFestivalWatchlistAddMutation({
    onCompleted: () => snackbarMsg(commonFestivalMsgs.watchListAddSuccess),
    onError: snackbarError,
  })

  const [removeFromWatchList] = useFestivalWatchlistRemoveMutation({
    onCompleted: () => snackbarMsg(commonFestivalMsgs.watchListRemoveSuccess),
    onError: snackbarError,
  })

  const handlers = useMemo(
    () => ({
      festivalLineup: () => history.push('/festival/lineup'),
      festivalAwards: () => history.push('/festival/awards'),
      festivalVote: () => history.push('/festival/vote'),
      myFestival: () => history.push('/festival/my-festival'),

      // Overrides
      addToWatchList,
      removeFromWatchList,
      playFeature: ({ slug, festivalId }) => history.push(`/festival/player/${festivalId}/${slug}`),
      viewDetails: ({ slug, type = 'film', id }) => {
        const typeRouteMap = {
          person: `/actor/${slug}`,
          groupWatch: `/player/group-watch/${id}`,
          film: `/festival/film/${slug}`,
        }
        history.push(typeRouteMap[type])
      },
    }),
    [addToWatchList, history, removeFromWatchList],
  )

  return <OverrideButtonHandlers handlers={handlers}>{children}</OverrideButtonHandlers>
}
